const performanceDashboard = {
  supplierSelector: {
    label: 'Escolher Frota:',
  },
};

export default performanceDashboard;
